// useDocumentTitle — a page declares its tab-title LEAF ("Sites", "My profile").
//
// The full title is composed by ThemeProvider as `[leaf · project ?? RubixEMS]`
// — most-specific-first, with the brand only filling the context slot when
// there's no project (FRONTEND-PATTERNS §Document title). Call once per page
// with the page's own already-translated name; OMIT the arg for pages whose
// context alone is the title (project home → the project name; pre-auth → just
// RubixEMS). The leaf clears on unmount, so a page without it falls back to the
// context cleanly (no stale title).

import { useEffect } from 'react';
import { useTitleStore } from '../stores/titleStore.js';

export function useDocumentTitle(segment?: string): void {
  const setSegment = useTitleStore((s) => s.setSegment);
  useEffect(() => {
    setSegment(segment ?? null);
    return () => setSegment(null);
  }, [segment, setSegment]);
}
